<template>
  <mm-modal
    class="cancel-appointment-modal"
    width="640px"
    :visible.sync="localVisible"
    @on-close="hideModal"
  >
    <div
      v-if="loading || showLoading"
      style="display: flex;flex-direction: column;justify-items: center;align-items: center;margin: 64px 0;"
    >
      <img
        class="loading-img"
        src="@/assets/images/wechat/loading.gif"
      >
      <div style="font-weight: bold;margin: 16px 0;">
        产品激活中
      </div>
      <div>
        正在为您激活CRM系统，请稍等
      </div>
      <div v-if="showLoading">
        如有疑问请联系在线客服
      </div>
    </div>
    <div
      v-if="showQr"
      style="display: flex;flex-direction: column;justify-items: center;align-items: center;margin: 40px 0;gap: 12px;"
    >
      <div style="font-size: 18px;font-weight: bold;display: flex;align-items: center;justify-content: center;">
        <img
          style="width: 28px;margin-right: 8px;"
          src="@/assets/images/wechat/success.svg"
        >
        激活成功
      </div>
      <div style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
        <div>
          扫描二维码 添加您的<a>专属服务顾问</a>
        </div>
        <div>
          获得最佳使用体验！
        </div>
      </div>
      <img
        src="@/assets/images/wechat/vector.svg"
      >
      <div style="width: 196px; height: 196px; padding: 16px; background: #ECF5FF; border-radius: 8px; border: 4px #65A1FF solid; flex-direction: column; justify-content: center; align-items: center; gap: 12px; display: inline-flex">
        <div style="position: relative;width: 164px; height: 164px; padding-left: 62px; padding-right: 62px; padding-top: 60px; padding-bottom: 60px; justify-content: flex-start; align-items: center; gap: 10px; display: inline-flex">
          <img
            style="width: 164px; align-self: stretch; left: 0px; top: 0px; position: absolute; border-radius: 6px"
            :src="qrCode"
          >
        </div>
      </div>
      <div>👆请添加我的企业微信</div>
    </div>
    <div
      v-if="showSuccessTip"
      style="display: flex;flex-direction: column;justify-items: center;align-items: center;margin: 64px 0;gap: 12px;"
    >
      <div style="font-size: 18px;font-weight: bold;display: flex;align-items: center;justify-content: center;">
        <img
          style="width: 28px;margin-right: 8px;"
          src="@/assets/images/wechat/success.svg"
        >
        激活成功
      </div>
      <div style="width: 406px; text-align: center; color: #666666; font-size: 16px; font-family: PingFang SC; font-weight: 400; line-height: 24px; word-wrap: break-word">
        您已成功激活CRM系统<br>感谢您的使用，我们将尽快为您安排服务顾问
      </div>
    </div>
  </mm-modal>
</template>

<script>
import OrderApi from '@api/order'

/**
 * 0 展示二维码
1 联系在线客服
2 只展示成功文案
 */

export default {
  name: 'WeChatModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderId: {
      type: String,
      default: '',
    },
    clientId: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: String | Number,
      default: '',
    }
  },
  data() {
    return {
      localVisible: false,
      loading: false,
      showLoading: false,
      showQr: false,
      showSuccessTip: false,
      qrCode: '',
      pollTimer: null,
    };
  },
  methods: {
    hideModal() {
      this.localVisible = false;
      this.$emit('onClose', {});
    },
    async activateOrder() {
      this.loading = true;
      await OrderApi.editOrderActivate({
        order_id: this.orderId
      })
      await this.fetchQrCode();
    },
    async fetchQrCode() {
      // 轮询查询激活状态
      const pollActivationStatus = async () => {
        const response = await OrderApi.getActiveQrcode({
          client_id: this.clientId
        });
        const status = Number(response.status);
        if (status === 1) {
          this.pollTimer = setTimeout(pollActivationStatus, 1000); // Poll every 2 seconds
        } else if (status === 0) {
          this.loading = false;
          this.showQr = true;
          this.qrCode = response.qr_code;
        } else if (status === 2) {
          this.loading = false;
          this.showSuccessTip = true;
        }
      };
      pollActivationStatus();
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.localVisible = val
        if (val) {
          this.activateOrder()
        }
      },
      immediate: true
    },
    localVisible: {
      handler(val) {
        if (!val) {
          // 停止轮询
          clearTimeout(this.pollTimer);
          this.$emit('onClose', {});
        }
      }
    }
  }
};
</script>
